// ======================================================================
// File Name       : MessageThreadContants
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const MESSAGE_TYPE = {
  ROUTE: 0,
  SUB: 1,
};

export const MESSAGE_FILTER = {
  SENT: 0,
  RECEIVED: 1,
};

export const MAX_MESSAGE_NUM = 20;

export const DELETE_MSG = '本メッセージは削除されました。';

export const MSG_NOT_ACCEPT_FILE = 'bat,exe,js,text/javascript,application/javascript,msi,pkg,app,flv,application/x-msdownload';

export const MESSAGE_OPERATION_FLAG = {
  NOT_CHECK: 0,
  CHECK: 1,
};
